module.exports = __webpack_public_path__ + "images/scaling-commons.png?v=005c82df2eff728962696478d359d886";